<script setup lang="ts">
import { useConfirmationDialog } from '@/composables/useConfirmationDialog';
import CommonDialog from '@/components/CommonDialog.vue';

const {
    state,
    respond,
} = useConfirmationDialog();
</script>

<template>
    <CommonDialog
        v-model="state.isOpen"
        :title="state.options?.title ?? ''"
        size="xsmall"
        hide-close
        persistent
    >
        <template #default>
            <div
                v-if="state.options?.description"
                class="text-body-2 text-medium-emphasis"
            >
                {{ state.options?.description }}
            </div>
        </template>
        <template #actions>
            <VBtnSecondary
                :disabled="state.buttonsDisabled"
                data-testid="buttonCancel"
                @click="respond(false)"
            >
                {{ state.options?.cancelText }}
            </VBtnSecondary>
            <VBtnPrimary
                :color="state.options?.confirmColor"
                :loading="state.isLoading"
                :disabled="state.buttonsDisabled"
                data-testid="buttonConfirm"
                @click="respond(true)"
            >
                {{ state.options?.confirmText }}
            </VBtnPrimary>
        </template>
    </CommonDialog>
</template>
